import { create } from "zustand";
import { persist, createJSONStorage, devtools } from "zustand/middleware";
import { createAuthSlice, AuthSlice } from "./authSlice";
export type GlobalStore = AuthSlice;

export const createGlobalStore = () =>
  create<GlobalStore>()(
    devtools(
      persist(
        (...a) => ({
          ...createAuthSlice(...a),
        }),
        {
          name: "global-store",
          storage: createJSONStorage(() => localStorage),
          partialize: (state) => ({
            memberId: state.memberId,
            accessToken: state.accessToken,
          }),
          onRehydrateStorage: () => (state) => {
            state?.setIsLoading(false);
          },
        },
      ),
    ),
  );
